/**
 * Honeypot bot protection utility
 *
 * Honeypot fields are hidden form inputs that humans won't see or fill,
 * but automated bots will. If the field has a value, it's likely a bot.
 */

/** Field name that looks legitimate to bots */
export const HONEYPOT_FIELD = "website_url";

/** Check if honeypot was triggered (bot detected) */
export function isHoneypotTriggered(value: unknown): boolean {
  return typeof value === "string" && value.length > 0;
}
